"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reduceReducers = _interopRequireDefault(require("reduce-reducers"));

var _reduxPersist = require("redux-persist");

var _storage = _interopRequireDefault(require("redux-persist/lib/storage"));

var _reduxOrm = require("redux-orm");

var _orm = _interopRequireDefault(require("./orm"));

var _initialState = _interopRequireDefault(require("./initialState"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    exportedJSON: '',
    collapsed: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var session = _orm["default"].session(state);

  var exportJSON = function exportJSON() {
    return session.Menu.all().toModelArray().map(function (menu) {
      var ref = menu.ref;

      var inRegion = function inRegion(bannerGroups, region) {
        return bannerGroups.filter({
          region: region
        }).toModelArray().map(function (bannerGroup) {
          var refBannerGroup = bannerGroup.refBannerGroup;
          return _objectSpread(_objectSpread({}, refBannerGroup), {}, {
            banners: bannerGroup.banners.toRefArray()
          });
        });
      };

      return _objectSpread(_objectSpread({}, ref), {}, {
        rightRegion: {
          bannerGroups: inRegion(menu.bannerGroups, 'right')
        },
        bottomRegion: {
          bannerGroups: inRegion(menu.bannerGroups, 'bottom')
        }
      });
    });
  };

  switch (action.type) {
    case 'TOGGLE_COLLAPSE':
      return _objectSpread(_objectSpread({}, state), {}, {
        collapsed: !state.collapsed
      });

    case 'EXPORT_JSON':
      var force = action.payload.force;
      return _objectSpread(_objectSpread({}, state), {}, {
        exportedJSON: force || !state.exportedJSON ? exportJSON() : state.exportedJSON
      });

    case 'CLEAR_EXPORT_JSON':
      return _objectSpread({
        exportedJSON: null
      }, state);

    case 'RESET_STATE':
      return (0, _initialState["default"])();

    default:
      return state;
  }
};

var reducedReducers = (0, _reduceReducers["default"])((0, _reduxOrm.createReducer)(_orm["default"]), reducer);
var ormPersistConfig = {
  key: 'MenuBuilderComponent',
  storage: _storage["default"],
  blacklist: ['exportedJSON']
};

var _default = (0, _redux.combineReducers)({
  MenuBuilderComponent: (0, _reduxPersist.persistReducer)(ormPersistConfig, reducedReducers)
});

exports["default"] = _default;